// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3SYck","footer":"ModalError_footer__1DP84"};